import React from 'react';
import ManagementView from '../teacher/lessons_hub/ManagementView';

export default function LessonApprovals() {
  return <ManagementView />;
}
